// Facade del lente, la rotación y las escrituras del backoffice de `retail-catalog-business`.
//
// **NO HAY ADAPTER MOCK, y no se vuelve a agregar.** Ver el porqué en el facade del wizard.
import { inventoryLensClient, inventoryWriteClient } from './backoffice.client';

export const inventoryLensApi = inventoryLensClient;

export const inventoryWriteApi = inventoryWriteClient;

export { productLabel } from './inventoryLensMapper';

export type {
    AccessorySubcategory,
    BackofficeCreateKitRequest,
    BackofficeCreateProductRequest,
    BackofficeCreateServiceRequest,
    BackofficeCreateSkuPriceRequest,
    BackofficeCreateTransferRequest,
    BackofficeRegisterAdjustmentRequest,
    BackofficeRegisterEntryRequest,
    BackofficeUpdateProductRequest,
    IdempotencyHeader,
    ActiveSalePromotionSummary,
    InventoryLensAlerts,
    InventorySourceStatus,
    InventoryLensApi,
    InventoryLensCoverage,
    InventoryLensCriticalResponseWire,
    InventoryLensFilter,
    InventoryLensListItem,
    InventoryLensListItemWire,
    InventoryLensListParams,
    InventoryLensListResponseWire,
    InventoryLensListView,
    InventoryLensPeriod,
    InventoryLensSkuItem,
    InventoryLensSkuItemWire,
    InventoryLensStoreStock,
    InventoryLensUnavailableReason,
    InventoryLensView,
    InventoryMovementEntry,
    InventoryMovementEntryWire,
    InventoryMovementReason,
    EntryReason,
    RegisterEntryRequest,
    InventoryMovementType,
    InventoryPieceEntry,
    InventoryPieceStatus,
    InventoryLiveReservation,
    InventorySkuDetail,
    InventorySkuParams,
    InventoryStorePieces,
    InventoryStoreReserved,
    InventoryWriteApi,
    ItemType,
    InventoryWriteOptions,
    ListTransfersResponse,
    Product,
    ProductCategory,
    ProductCategoryWire,
    ProductTier,
    SkuPriceEntry,
    SkuPriceEntryWire,
    SkuPriceHistory,
    StoreRotationRow,
    TransferResponse,
    TransferStateFilter,
} from './contract';
